import {
  AccessToken,
  IDToken,
  RefreshToken,
  SessionObject,
  UserClaims,
} from '@okta/okta-auth-js';
import {Reducer} from 'react';

export type AuthProps = {
  isAuthenticated: boolean;
  accessToken?: AccessToken;
  idToken?: IDToken;
  refreshToken?: RefreshToken;
  user?: UserClaims;
  initialState: any;
  session: SessionObject | undefined;
};

export type ActionProps = {type: string} & AuthProps;

export const AuthState = {
  isAuthenticated: false,
  accessToken: undefined,
  idToken: undefined,
  refreshToken: undefined,
  user: undefined,
  initialState: undefined,
  session: undefined,
};

export const ActionTypes = {
  AUTHENTICATION_SUCCESS: 'AUTHENTICATION_SUCCESS',
  UPDATE_USER: 'UPDATE_USER',
  UPDATE_STATE: 'UPDATE_STATE',
  UPDATE_SESSION: 'UPDATE_SESSION',
  AUTHENTICATION_LOGOUT: 'AUTHENTICATION_LOGOUT',
};

const getUpdateParams = (state: AuthProps, queryParams) => {
  const {initialState} = state;
  if (!initialState) {
    return queryParams;
  } else if (Object.keys(initialState).length > 0) {
    return initialState;
  } else {
    return {};
  }
};

const AuthReducer: Reducer<AuthProps, ActionProps> = (state, action) => {
  switch (action.type) {
    case ActionTypes.AUTHENTICATION_SUCCESS: {
      return {
        ...state,
        isAuthenticated: action.isAuthenticated,
        accessToken: action.accessToken,
        idToken: action.idToken,
        refreshToken: action.refreshToken,
        user: action.user,
        initialState: getUpdateParams(state, action.initialState),
      };
    }
    case ActionTypes.UPDATE_USER: {
      return {
        ...state,
        user: action.user,
      };
    }
    case ActionTypes.UPDATE_STATE: {
      return {
        ...state,
        initialState: action.initialState,
      };
    }
    case ActionTypes.UPDATE_SESSION: {
      return {
        ...state,
        session: action.session,
      };
    }
    case ActionTypes.AUTHENTICATION_LOGOUT: {
      return {
        ...state,
        isAuthenticated: false,
        accessToken: undefined,
        idToken: undefined,
        user: undefined,
      };
    }
    default:
      return state;
  }
};

export default AuthReducer;
